import { render, staticRenderFns } from "./Internships.vue?vue&type=template&id=45a584c6&scoped=true"
import script from "./Internships.vue?vue&type=script&lang=js"
export * from "./Internships.vue?vue&type=script&lang=js"
import style0 from "./Internships.vue?vue&type=style&index=0&id=45a584c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a584c6",
  null
  
)

export default component.exports